import React from "react";
import { Link } from "react-router-dom";
import fr from "@/locales/fr.json";
import { CheckCircle2, ArrowLeft, LineChart } from "lucide-react";

export default function ThankYou() {
  const t = fr.thankyou;

  React.useEffect(() => {
    document.documentElement.lang = "fr";
  }, []);

  return (
    <main
      data-testid="page-thankyou"
      className="min-h-screen bg-[#F8FAFC] flex flex-col"
    >
      <div className="bg-[#0A192F] text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-6">
          <Link
            data-testid="thankyou-brand-link"
            to="/"
            className="inline-flex items-center gap-3 text-white"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-[#059669]">
              <LineChart className="h-5 w-5 text-white" />
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-base font-semibold tracking-tight text-white">
                {fr.brand.name}
              </span>
              <span className="text-[11px] uppercase tracking-widest text-[#94A3B8]">
                {fr.brand.tagline}
              </span>
            </span>
          </Link>
        </div>
      </div>

      <div className="flex-1 flex items-center">
        <div className="mx-auto max-w-3xl w-full px-4 sm:px-8 lg:px-12 py-16 lg:py-24">
          <div className="bg-white border border-[#E2E8F0] p-8 lg:p-14">
            <span className="inline-flex h-14 w-14 items-center justify-center rounded-sm bg-[#ECFDF5] text-[#047857]">
              <CheckCircle2 className="h-7 w-7" />
            </span>
            <p className="mt-6 font-mono text-xs uppercase tracking-widest text-[#059669]">
              {t.eyebrow}
            </p>
            <h1 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A192F] leading-tight">
              {t.title}
            </h1>
            <p className="mt-6 text-base text-[#334155] leading-relaxed">
              {t.body}
            </p>
            <p className="mt-4 text-sm text-[#64748B] leading-relaxed">
              {t.next}
            </p>
            <Link
              data-testid="thankyou-back-home"
              to="/"
              className="mt-10 inline-flex items-center gap-2 rounded-sm bg-[#059669] px-6 py-3 text-sm font-semibold text-white hover:bg-[#047857]"
            >
              <ArrowLeft className="h-4 w-4" />
              {t.backHome}
            </Link>
          </div>
        </div>
      </div>

      <footer className="bg-[#0A192F] text-[#94A3B8]">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-6 text-xs">
          {fr.footer.rights}
        </div>
      </footer>
    </main>
  );
}
